import { createAction, props } from '@ngrx/store';
import { MappedHttpErrorResponse } from '@adnova/jf-ng-components';
import { ProblemDTO, UserAnnouncementDTO } from '../../openapi/shell-service-openapi';

/**
 * Actions für die Archiv-Seite (Endnutzer-Ansicht aller Announcements).
 */
export class AnnouncementArchiveEntitiesActions {
  private static readonly prefix = '[Announcement Archive Entities]';

  /** Lädt eine Seite der Archiv-Liste. */
  static loadPage = createAction(
    `${this.prefix} Load Page`,
    props<{ page: number; size: number }>(),
  );

  /** Seite erfolgreich geladen. */
  static loadPageSuccess = createAction(
    `${this.prefix} Load Page Success`,
    props<{ announcements: UserAnnouncementDTO[]; totalElements: number; page: number }>(),
  );

  /** Fehler beim Laden der Seite. */
  static loadPageFailure = createAction(
    `${this.prefix} Load Page Failure`,
    props<{ error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Lädt ein Announcement-Bild für die Archiv-Karte. */
  static loadImage = createAction(
    `${this.prefix} Load Image`,
    props<{ imageId: string }>(),
  );

  /** Bild erfolgreich geladen. */
  static loadImageSuccess = createAction(
    `${this.prefix} Load Image Success`,
    props<{ imageId: string; blobUrl: string }>(),
  );

  /** Fehler beim Laden des Bildes. */
  static loadImageFailure = createAction(
    `${this.prefix} Load Image Failure`,
    props<{ imageId: string; error: MappedHttpErrorResponse<ProblemDTO> }>(),
  );

  /** Setzt den State auf den Initialzustand zurück (beim Verlassen der Archiv-Seite). */
  static reset = createAction(
    `${this.prefix} Reset`,
  );
}
